import dayjs, { Dayjs } from 'dayjs';

export const convertDateFormat = (date: string | Date | Dayjs): string => {
  return date ? dayjs(date, 'DD.MM.YYYY').toString() : '';
};
